import * as types from "../actions/actionTypes";
import { TOGGLE_EDIT_INFO_PERMISSION } from "../actions/actionTypes";

const initialState = {
  drivers: {},
  error: {},
  driver_order_history: {},
  driver_order_history_error: {},
  customMessages:null
};

const driver = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_DRIVER:
      return {
        ...state,
        drivers: action.payload,
        driver_order_history_error: {},
      };
    case types.GET_DRIVER_ORDER_HISTORY:
      return {
        ...state,
        driver_order_history: action.payload,
        driver_order_history_error: {},
      };
    case types.CLEAR_DRIVER_ORDER_HISTORY:
      return {
        ...state,
        driver_order_history: {},
      };
    case types.GET_DRIVER_ORDER_HISTORY_ERROR:
      return {
        ...state,
        driver_order_history_error: action.payload,
        driver_order_history: {},
      };
    case types.DELETE_DRIVER:
      return {
        ...state,
        drivers: {
          data: state.drivers.data.filter(
            (driver) => driver.driver__id !== action.payload,
          ),
          status: "success",
        },
      };
    case types.TOGGLE_DRIVER_STATUS:
      const index = state.drivers.data.findIndex(
        (driver) => driver.driver__id === action.payload,
      );
      let newDriverState = state.drivers;
      newDriverState.data[index].driver__is_active =
        !newDriverState.data[index].driver__is_active;
      return {
        ...state,
        drivers: newDriverState,
      };
    case types.TOGGLE_AUTO_ASSIGN_ORDERS: {
      const index = state.drivers.data.findIndex(
        (driver) => driver.driver__id === action.payload,
      );
      let newDriverState = state.drivers;
      newDriverState.data[index].driver__can_auto_assign =
        !newDriverState.data[index].driver__can_auto_assign;
      return {
        ...state,
        drivers: newDriverState,
      };
    }
    case types.TOGGLE_EDIT_INFO_PERMISSION: {
      const index = state.drivers.data.findIndex(
        (driver) => driver.driver__id === action.payload,
      );
      let newDriverState = state.drivers;
      newDriverState.data[index].driver__can_edit_info =
        !newDriverState.data[index].driver__can_edit_info;
      return {
        ...state,
        drivers: newDriverState,
      };
    }
    case types.CREATE_DRIVER:
      return {
        ...state,
        drivers: {
          data: [...state.drivers.data, action.payload.data],
          status: action.payload.status,
        },
      };
    case types.EDIT_DRIVER: {
      const index = state.drivers.data.findIndex(
          (driver) => driver.driver__id === action.payload.data.driver__id,
      );
      let newDriverState = state.drivers;
      newDriverState.data[index].first_name = action.payload.data.first_name;
      newDriverState.data[index].last_name = action.payload.data.last_name;
      newDriverState.data[index].phone_number = action.payload.data.phone_number;
      newDriverState.data[index].vehicle_type = action.payload.data.vehicle_type;
      return {
        ...state,
        drivers: newDriverState,
      };
    }

    case types.CREATE_DRIVER_ERRORS:
      return {
        ...state,
        error: action.payload,
      };
    case types.CLEAR_DRIVER_ERROR:
      console.log(state.error);
      return {
        ...state,
        error: null,
      };
    case types.CHANGE_DRIVER_PROFILE_PICTURE:
      const driverIndex = state.drivers.data.findIndex(
        (driver) => driver.driver__id === +action.payload.id,
      );
      const newDrivers = state.drivers;
      newDrivers.data[driverIndex].profile_pic = action.payload.profile_pic;
      return {
        ...state,
        drivers: newDrivers,
      };
      case "FETCH_DRIVER_CUSTOM_MESSAGES": {
        return {
          ...state,
          customMessages: action.payload,
        };
      }
    case "ADD_DRIVER_CUSTOM_MESSAGE":
      return {
        ...state,
        customMessages: [...state.customMessages, action.payload],
      };

    case "DELETE_DRIVER_CUSTOM_MESSAGE":
      return {
        ...state,
        customMessages: state.customMessages.filter(
          (msg) => msg.id !== action.payload
        ),
      };
      case "TOGGLE_DRIVER_CUSTOM_MESSAGE":
      {
        const index =state.customMessages.findIndex(
          (msg) => msg.id === action.payload,
        );
        let newCustomMessages = state.customMessages;
        newCustomMessages[index].is_active =
          !newCustomMessages[index].is_active;
        return {
          ...state,
          customMessages: newCustomMessages,
        };
      }
    default:
      return state;
  }
};

export default driver;
